// ? Dark Mode Theme is since 2023 not updated and at the moment kept unused
// ** Utils
import spacing from '@/theme/settings/spacing';
import breakpoints from '@/theme/settings/breakpoints';

// ** Types
import type { ThemeOptions } from '@mui/material/styles';

const darkTheme: ThemeOptions = {
	layout: {
		pagePx: { xs: 4, md: 10, lg: 20 },
		twoColMinWidthPx: 1120,
		desktopGutter: 20,
		desktopColumnGap: { xs: 28, sm: 26, lg: 24 },
		heroPanelPx: { xs: 4, sm: 8, lg: 16 },
		contentMaxWidthPx: 1440,
		heroPanelContentMaxWidthPx: 592
	},
	palette: {
		mode: 'dark',
		primary: {
			// light: '#F0AB00',
			main: '#DF7A00'
			// dark: '#BD4F19',
			// contrastText: '#1E1E1E'
		},
		// secondary: {
		// 	light: '#b700ff',
		// 	main: '#ff0055',
		// 	dark: '	#7900a8',
		// 	contrastText: '#600085'
		// },
		// error: {
		// 	light: '#ff0000',
		// 	main: '#cc060c',
		// 	dark: '#cf000f',
		// 	contrastText: '#ff3366'
		// },
		// warning: {
		// 	light: '#f9e154',
		// 	main: '#f2930c',
		// 	dark: '#f0541e',
		// 	contrastText: '#f0ad4e'
		// },
		// info: {
		// 	light: '#27ace2',
		// 	main: '#0000ff',
		// 	dark: '#0b4a8f',
		// 	contrastText: '#4186c6'
		// },
		// success: {
		// 	light: '#ccff33',
		// 	main: '#4b9609',
		// 	dark: '#2d5d07',
		// 	contrastText: '#22bb33'
		// },
		text: {
			primary: '#FFFFFF',
			tertiary: 'rgba(255, 255, 255, 0.72)'
			// disabled: '#C0C0C0'
		},
		loginOverlayCta: {
			main: '#82786F',
			dark: '#786F67',
			contrastText: '#FFFFFF'
		},
		externalLink: {
			main: '#8AB4F8'
		},
		// common: {
		// 	black: '#000000',
		// 	white: '#ffffff'
		// },
		// contrastThreshold: 0.5,
		// tonalOffset: {
		// 	light: 0.5,
		// 	dark: 0.5
		// },
		// grey: {
		// 	50: '#f8f8fa',
		// 	100: '#e5e6eb',
		// 	200: '#c0c2ce',
		// 	300: '#d2d4dc',
		// 	400: '#afafaf',
		// 	500: '#999999',
		// 	600: '#5b5b5b',
		// 	700: '#5b5b5b',
		// 	800: '#5b5b5b',
		// 	900: '#444444',
		// 	A100: '#EEEEEE',
		// 	A200: '#CCCCCC',
		// 	A400: '#666666',
		// 	A700: '#333333'
		// },
		divider: '#0000002E',
		softGrey: {
			main: '#A3A3A3'
		}
		// action: {
		// 	// active: '',
		// 	hover: '#ff6600',
		// 	hoverOpacity: 0.5,
		// 	selected: '#302100', // <--- Test
		// 	selectedOpacity: 0.5,
		// 	// disabled: '',
		// 	disabledOpacity: 0.5,
		// 	// disabledBackground: '',
		// 	focus: '#302100',
		// 	focusOpacity: 0.5,
		// 	activatedOpacity: 0.5
		// },
		// background: {
		// 	default: '#00000000',
		// 	paper: '#121212;'
		// }
	},
	...spacing,
	breakpoints: {
		keys: ['xs', 'sm', 'md', 'lg', 'xl'],
		values: {
			xs: 0,
			sm: 653,
			md: 960,
			lg: 1280,
			xl: 1920
		}
	},
	typography: {
		h1: undefined,
		h2: undefined,
		h3: undefined,
		h4: undefined,
		h5: undefined,
		h6: undefined,
		subtitle1: undefined,
		subtitle2: undefined,
		body1: undefined,
		body2: undefined,
		button: undefined,
		// caption is defined below as part of the new type scale
		'h1-normal': {
			fontSize: 60,
			fontWeight: 'bolder',
			textTransform: 'uppercase'
		},
		'h1-primary': {
			fontSize: 60,
			fontWeight: 'bolder',
			color: '#DF7A00',
			textTransform: 'uppercase'
		},
		'h2-normal': {
			fontSize: 40,
			fontWeight: 'bold'
		},
		'h2-primary': {
			fontSize: 40,
			fontWeight: 'bold',
			color: '#DF7A00'
		},
		'h3-normal': {
			fontSize: 28,
			fontWeight: 'bold'
		},
		'h3-primary': {
			fontSize: 28,
			fontWeight: 'bold',
			color: '#DF7A00'
		},
		'h4-normal': {
			fontSize: 22,
			fontWeight: 'bold'
		},
		'h4-primary': {
			fontSize: 22,
			fontWeight: 'bold',
			color: '#DF7A00',
			overflowWrap: 'anywhere'
		},
		'subheadline-normal': {
			fontSize: 17,
			fontWeight: 'bold'
		},
		'subheadline-primary': {
			fontSize: 17,
			fontWeight: 'bold',
			color: '#DF7A00'
		},
		'button-normal': {
			fontSize: 18,
			fontWeight: 'bold'
		},
		'button-primary': {
			fontSize: 18,
			color: '#DF7A00',
			fontWeight: 'bold'
		},
		// New type scale variants
		'display-lg': {
			fontFamily: '"DIN Next LT Pro"',
			fontSize: 'clamp(2.5rem, 2.25rem + 1.25vw, 3rem)',
			fontWeight: 500,
			lineHeight: 'clamp(2.875rem, 2.625rem + 1.25vw, 3.375rem)',
			letterSpacing: '-0.64px',
			whiteSpace: 'pre-line',
			[breakpoints.up('lg')]: { letterSpacing: '-0.96px' }
		},
		'display-md': {
			fontFamily: '"DIN Next LT Pro"',
			fontSize: 'clamp(2.5rem, 2.25rem + 1.25vw, 3rem)',
			fontWeight: 400,
			lineHeight: 'clamp(2.875rem, 2.625rem + 1.25vw, 3.375rem)',
			letterSpacing: 'clamp(-0.048rem, -0.12vw - 0.019rem, -0.04rem)',
			whiteSpace: 'pre-line'
		},
		'title-lg': {
			fontFamily: '"DIN Next LT Pro"',
			fontSize: '2.5rem',
			fontWeight: 400,
			lineHeight: '2.875rem',
			letterSpacing: '-1.2px',
			[breakpoints.up('md')]: {
				fontSize: '3rem',
				lineHeight: '3.375rem',
				letterSpacing: '-1.44px'
			}
		},
		'title-md': {
			fontFamily: '"DIN Next LT Pro"',
			fontSize: '1.5rem',
			fontWeight: 400,
			lineHeight: '1.875rem',
			letterSpacing: '-0.48px',
			[breakpoints.up('lg')]: {
				fontSize: '2rem',
				lineHeight: '2.375rem',
				letterSpacing: '-0.64px'
			}
		},
		'title-sm': {
			fontFamily: '"DIN Next LT Pro"',
			fontSize: 'clamp(1rem, 0.75rem + 1.25vw, 1.5rem)',
			fontWeight: 400,
			lineHeight: 'clamp(1.375rem, 0.8125rem + 1.5625vw, 2rem)',
			letterSpacing: 'clamp(-0.672px, -0.0233vw - 0.373px, -0.448px)'
		},
		'body-md': {
			fontFamily: '"DIN Next LT Pro"',
			fontSize: 'clamp(1rem, 0.9554rem + 0.2232vw, 1.125rem)',
			fontWeight: 400,
			lineHeight: 'clamp(1.375rem, 1.2857rem + 0.4464vw, 1.625rem)',
			letterSpacing: '-0.05px'
		},
		'body-sm': {
			fontFamily: '"DIN Next LT Pro"',
			fontSize: '1rem',
			fontWeight: 400,
			lineHeight: '1.375rem',
			letterSpacing: '-0.05px'
		},
		'body-lg': {
			fontFamily: '"DIN Next LT Pro"',
			fontSize: 'clamp(1rem, 0.9108rem + 0.4464vw, 1.25rem)',
			fontWeight: 400,
			lineHeight: 'clamp(1.375rem, 1.1964rem + 0.8929vw, 1.875rem)',
			letterSpacing: '-0.05px'
		},
		label: {
			fontFamily: '"DIN Next LT Pro"',
			fontSize: '0.875rem',
			fontWeight: 400,
			lineHeight: '1.25rem',
			letterSpacing: '-0.05px'
		},
		caption: {
			fontFamily: '"DIN Next LT Pro"',
			fontSize: '0.75rem',
			fontWeight: 400,
			lineHeight: '1rem',
			letterSpacing: '-0.05px',
			[breakpoints.up('md')]: { fontSize: '0.875rem', lineHeight: '1.125rem' }
		},
		'panel-heading': {
			fontFamily: '"DIN Next LT Pro"',
			fontSize: '1rem',
			fontWeight: 500,
			lineHeight: '1.375rem',
			letterSpacing: '-0.05px',
			[breakpoints.up('md')]: {
				fontSize: '1.125rem',
				lineHeight: '2rem'
			}
		},
		'body-xl': {
			fontFamily: '"DIN Next LT Pro"',
			fontSize: '1.25rem',
			fontWeight: 400,
			lineHeight: '1.75rem',
			letterSpacing: '-0.01px'
		},
		nav: {
			fontFamily: '"DIN Next LT Pro"',
			fontSize: '1.5rem',
			fontStyle: 'normal',
			fontWeight: 300,
			lineHeight: '2rem',
			letterSpacing: '-0.012px',
			[breakpoints.up('md')]: {
				fontWeight: 400
			}
		},
		subnav: {
			fontFamily: '"DIN Next LT Pro"',
			fontSize: '1.25rem',
			fontStyle: 'normal',
			fontWeight: 300,
			lineHeight: '1.5rem',
			letterSpacing: '-0.01px',
			[breakpoints.up('md')]: {
				fontSize: '1rem',
				fontWeight: 400,
				lineHeight: '1.375rem',
				letterSpacing: '-0.05px'
			}
		}
	},
	components: {
		MuiCssBaseline: {
			styleOverrides: {
				body: {
					background: 'url("/images/background/background-dark.jpg")',
					backgroundSize: 'cover',
					backgroundAttachment: 'fixed'
				},
				html: {
					background: '#000'
				}
			}
		},
		MuiInputBase: {
			styleOverrides: {
				input: {
					'&:-webkit-autofill': {
						WebkitBoxShadow: '0 0 0 100px #272727 inset !important'
					}
				}
			}
		},
		// MuiFormControl: {
		// 	styleOverrides: {
		// 		root: {
		// 			marginTop: 16,
		// 			marginBottom: 8
		// 		}
		// 	}
		// },
		MuiButton: {
			styleOverrides: {
				root: {
					minHeight: 30.75
				}
			}
		},
		MuiAvatar: {
			styleOverrides: {
				root: {
					color: '#FFF'
				}
			}
		},
		MuiTypography: {
			defaultProps: {
				variantMapping: {
					// Map the new variant to render a <h1> by default
					'h1-normal': 'h1',
					'h1-primary': 'h1',
					'h2-normal': 'h2',
					'h2-primary': 'h2',
					'h3-normal': 'h3',
					'h3-primary': 'h3',
					'h4-normal': 'h4',
					'h4-primary': 'h4',
					'subheadline-normal': 'p',
					'subheadline-primary': 'p',
					'button-normal': 'p',
					'button-primary': 'p',

					// AP01 type scale
					'display-lg': 'h1',
					'display-md': 'h2',
					'title-lg': 'h1',
					'title-md': 'h2',
					'title-sm': 'h3',
					'body-md': 'p',
					'body-sm': 'p',
					'body-lg': 'p',
					label: 'p',
					caption: 'small',
					'panel-heading': 'h2',
					'body-xl': 'p',
					nav: 'h3',
					subnav: 'span'
				}
			}
		},
		MuiAccordion: {
			styleOverrides: {
				root: {
					maxWidth: 1088,
					background: '#DF7A00',
					marginBottom: 3,
					'&:not(.Mui-expanded):hover': {
						background: '#DF7A0099'
					}
				}
			}
		},
		MuiAccordionSummary: {
			styleOverrides: {
				root: {
					padding: '10px 25px'
				},
				content: {
					'&.Mui-expanded': {
						margin: '12px 0'
					}
				}
			}
		},
		MuiAccordionDetails: {
			styleOverrides: {
				root: {
					padding: '0px 25px 20px 25px'
				}
			}
		}
	}
};

export default darkTheme;
